const isDevelopment = process.env.NODE_ENV === 'development';
export const BASE_URL = isDevelopment 
  ? 'http://localhost:5001' 
  : 'https://cabnhaul.com/.netlify/functions';